import React, { useMemo } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../assets/css/Issues.css";
import "../assets/css/Projects.css";
import "../assets/css/Permissions.css";
import "../assets/css/ViewCustomer.css";
import IssueCreateForm from "./issues/IssueCreateForm";
import { canPerformActionOnPage, PAGES, ACTIONS } from "../utils/roleAccess";

function AddIssue() {
  const navigate = useNavigate();
  const role = useMemo(() => {
    try {
      const u = localStorage.getItem("user");
      if (!u) return null;
      const user = JSON.parse(u);
      const primaryRole = Array.isArray(user.roles) && user.roles.length > 0 ? user.roles[0] : null;
      return (
        (primaryRole && (primaryRole.role_name || primaryRole.name || primaryRole.role)) ||
        user.role_name ||
        user.role ||
        null
      );
    } catch {
      return null;
    }
  }, []);

  const canCreate = canPerformActionOnPage(PAGES.ISSUES, ACTIONS.ADD, role);

  return (
    <div className="issues-container">
      <div className="viewlead-header" style={{ marginBottom: 12 }}>
        <button type="button" className="viewlead-back-link" onClick={() => navigate("/issues")}>
          <FaArrowLeft /> Back
        </button>
      </div>
      <div className="issues-main-card">
        <IssueCreateForm
          canCreate={canCreate}
          onCreated={() => {
            alert("Issue created successfully.");
            navigate("/issues", { replace: true });
          }}
        />
      </div>
    </div>
  );
}

export default AddIssue;


